<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'user' || $currentUser.role == 'account'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white" v-if="$currentUser.role != 'user' && $currentUser.role != 'account'">
            <div class="page-header">
                <h3 class="page-title">Пользователи</h3>
            </div>
            <div class="row mb-2" v-if="$currentUser.role == 'admin'">
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2">
                    <b-btn size="sm" variant="success" style="white-space: nowrap;" class="mainButton filterComponent"
                           v-b-modal.createUser>
                        Создать пользователя
                        <!--<i class="icon-fa icon-fa-pencil"></i>-->
                    </b-btn>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2" v-if="$currentUser.role === 'admin'">
                  <b-btn v-on:click="redirectToUserGroups" size="sm" variant="success" style="white-space: nowrap;" class="mainButton filterComponent"
                        >
                    Группы пользователей
                  </b-btn>
                </div>
            </div>
            <div class="row mb-2" v-if="$currentUser.role == 'admin'">
                <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                    <v-select :options="roles" required v-model="selectedRole"
                              class=""
                              :clearable="false"
                              :searchable="false"
                              placeholder="Роль"
                              multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>
                <div class="col-sm-5 col-md-3 col-lg-2 col-xl-2 mb-2 applyButton">
                    <b-input-group class="filterComponent">
                        <div></div>
                        <b-input-group-append>
                            <b-btn size="sm" text="Search" variant="success"
                                   class="mainButton"
                                   style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                                   @click="getUsers({sortBy: sortBy, sortDesc: sortDesc})">
                                Применить
                                <!--<i class="icon-fa icon-fa-search"></i>-->
                            </b-btn>
                            <b-btn size="sm" variant="outline-danger" class="mainButton" @click="resetFilters">Очистить
                                <!--<i class="icon-fa icon-fa-times"></i>-->
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <span class="alert-info" v-if="$currentUser.role == 'leader' && users.length == 0">Подчиненные пока не назначены.</span>
                    <div v-if="$currentUser.role == 'admin' || $currentUser.role == 'leader' && users.length > 0">
                        <b-table hover responsive bordered
                                 small
                                 :items="users"
                                 :fields="$currentUser.role == 'admin' ? fields : leaderFields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getUsers"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" class="btn btn-warning"
                                          @click.stop="edit(row)">
                                    <i class="icon-fa icon-fa-edit"></i>
                                </b-button>
                            </template>
                            <template v-slot:cell(subordinates)="row">
                                <span v-for="(item, index) in row.item.subordinates">
                                    <span v-if="index == row.item.subordinates.length - 1">{{item.name}}</span>
                                    <span v-if="index >= 0 && index < row.item.subordinates.length - 1">{{item.name}}, </span>

                                    <!--<div v-if="index < 2">{{item}}</div>-->
                                    <!--<div v-if="index > 2 && index < 4">-->
                                    <!--<font-awesome-icon icon="ellipsis-h"></font-awesome-icon>-->
                                    <!--</div>-->
                                </span>
                                <div v-if="row.item.subordinates == 0"></div>
                            </template>
                            <template v-slot:cell(leader)="row">
                                <div v-for="(item, index) in row.item.leader">
                                    {{item}}
                                </div>
                                <div v-if="row.item.leader == 0"></div>
                            </template>
                          <template v-slot:cell(user_group)="row">
                            <div v-if="row.item.user_group">{{row.item.user_group.title}}</div>
                          </template>
                            <template v-slot:cell(deactivated)="row">
                                <div v-if="row.item.deactivated == 0">
                                    <i class="icon-fa icon-fa-circle text-success"></i>
                                </div>
                                <div v-if="row.item.deactivated == 1">
                                    <i class="icon-fa icon-fa-circle text-danger"></i>
                                </div>
                            </template>
                            <template v-slot:cell(role)="row">
                                <div v-if="row.item.role == 'admin'">
                                    Админ
                                </div>
                                <div v-if="row.item.role == 'user'">
                                    Пользователь
                                </div>
                                <div v-if="row.item.role == 'leader'">
                                    Лидер
                                </div>
                                <div v-if="row.item.role == 'account'">
                                    Аккаунт
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <!--<div v-if="isMobile">-->
                    <!--<b-table hover responsive bordered stacked-->
                    <!--small-->
                    <!--:items="users"-->
                    <!--:fields="$currentUser.role == 'admin' ? fields : leaderFields"-->
                    <!--no-local-sorting-->
                    <!--:sort-by.sync="sortBy"-->
                    <!--@sort-changed="getUsers"-->
                    <!--:sort-desc.sync="sortDesc"-->
                    <!--:sort-direction="sortDirection">-->
                    <!--<template v-slot:cell(actions)="row">-->
                    <!--<b-button size="sm" class="btn btn-warning"-->
                    <!--@click.stop="edit(row)">-->
                    <!--<i class="icon-fa icon-fa-edit"></i>-->
                    <!--</b-button>-->
                    <!--</template>-->
                    <!--</b-table>-->
                    <!--</div>-->
                </div>
            </div>
            <b-modal id="createUser" ref="userCreateModal" size="md" title="Создать пользователя"
                     @hidden="hideCreateModal"
                     hide-footer>
                <CreateUserModal></CreateUserModal>
            </b-modal>

            <b-modal ref="userEditModal" @hidden="hideCreateModal" id="userEditModal" size="md" title="Редактировать пользователя" hide-footer>
                <EditUserModal v-bind:user="selectedUser"></EditUserModal>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import CreateUserModal from './modals/CreateUserModal.vue'
    import EditUserModal from './modals/EditUserModal.vue'
    import UsersService from '../../services/usersDataService'
    import saveFiltersMixin from "./mixins/saveFiltersMixin";

    export default {
        name: 'users',
        components: {
            CreateUserModal: CreateUserModal,
            EditUserModal: EditUserModal,
            UsersService: UsersService
        },
        mixins: [saveFiltersMixin],
        data() {
            return {
                users: [],
                isMobile: false,
                selectedUser: null,
                sortBy: 'created_at',
                sortDesc: true,
                sortDirection: 'desc',
                selectedRole: null,
                roles: [
                    {
                        'label': 'Админ',
                        'value': 'admin'
                    },
                    {
                        'label': 'Лидер',
                        'value': 'leader'
                    },
                    {
                        'label': 'Пользователь',
                        'value': 'user'
                    },
                    {
                        'label': 'Аккаунт',
                        'value': 'account'
                    }
                ],
                leaderFields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: 'Пользователь',
                        sortable: true
                    },
                    {
                        key: 'role',
                        label: 'Роль',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Дата добавления',
                        sortable: false
                    },
                    {
                        key: 'deactivated',
                        label: 'Статус',
                        sortable: false,
                        tdAttr: {'align': "center", 'width': '20px'}
                    },
                    {
                        key: 'actions',
                        label: 'Действия',
                        tdAttr: {'align': "center"}
                    }
                ],
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: 'Пользователь',
                        sortable: true
                    },
                    {
                        key: 'network_partner_id',
                        label: 'Buyer ID',
                        sortable: true
                    },
                    {
                        key: 'role',
                        label: 'Роль',
                        sortable: true
                    },
                    {
                        key: 'leader',
                        label: 'Лидер',
                        sortable: false
                    },
                    {
                        key: 'subordinates',
                        label: 'Подчинённые',
                        sortable: false
                    },
                    {
                      key: 'user_group',
                      label: 'Группа',
                      sortable: false
                    },
                    {
                        key: 'created_at',
                        label: 'Дата добавления',
                        sortable: false
                    },
                    {
                        key: 'deactivated',
                        label: 'Статус',
                        sortable: false,
                        tdAttr: {'align': "center", 'width': '20px'}
                    },
                    {
                        key: 'actions',
                        label: 'Действия',
                        tdAttr: {'align': "center"}
                    }
                ],
                window: {
                    width: 0,
                    height: 0
                },
                isXl: false,
                savedFiltersName: 'users',
            }
        },
        methods: {
            getUsers(sort) {
                if (this.useSavedFilters == true) {
                    let filters = this.getFilters(this.savedFiltersName)

                    if (filters) {
                        sort = filters.sort
                        this.selectedRole = filters.selectedRole
                    }
                }
                if (!sort) {
                    sort = this;
                }

                let roleArray = [];

                if (this.selectedRole && this.selectedRole.length != 0) {
                    this.selectedRole.forEach(function (role) {
                        roleArray.push(role.value)
                    });
                } else {
                    roleArray = null
                }

                let filtersObject = {
                    sort: {sortBy: sort.sortBy, sortDesc: sort.sortDesc},
                    selectedRole: this.selectedRole
                }

                this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))


                UsersService.getUsers(sort, roleArray)
                    .then(users => {
                        this.useSavedFilters = false
                        this.users = users;
                    })
            },
            resetFilters() {
                this.selectedRole = null;

                this.getUsers();
            },
            edit(item) {
                this.selectedUser = item
                this.$refs.userEditModal.show()
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                if (this.window.width < 415) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }

                if (this.window.width > 1199) {
                    this.isXl = true
                } else {
                    this.isXl = false
                }
            },
            hideCreateModal() {
                this.getUsers();

                this.$refs.userCreateModal.hide()
                this.$refs.userEditModal.hide()
            },
            redirectToUserGroups() {
              window.location.href = '/user-groups';
            }
        },
        beforeMount() {
            this.useSavedFilters = true
            this.getUsers()
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>
<style>
    .btn i {
        text-align: center !important;
    }

    .popover-body {
        max-height: 200px;
        overflow: scroll;
    }

    .vdp-datepicker input {
        background-color: white !important;
        width: 100% !important;
    }

    .dateFrom {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    .dateTo {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }

    .filterComponent {
        height: 30px !important;
    }

    .filterComponent .vs__dropdown-toggle {
        height: 30px !important;
    }

    .filterComponent .input-date {
        height: 30px !important;
    }

    .filterComponent .dateFrom {
        height: 30px !important;
    }

    .filterComponent .dateTo {
        height: 30px !important;
    }

    .input-date {
        border-top-left-radius: 0.2rem !important;
        border-bottom-left-radius: 0.2rem !important;
    }

    .mainButton {
        width: 100%;
    }

    .date {
        width: 100%;
    }

    .datePickerXl {
        min-width: 100% !important;
        max-width: 100% !important;
    }

    .input-group-append {
        width: 100%;
    }

    .myOffers {
        padding-top: 4px;
    }

    .groupComponent .vs__selected {
        margin: 2px 2px 4px 0 !important;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }

    @media (max-width: 576px) {
        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 768px) {
        .dateLeft .vdp-datepicker__calendar {
            right: 0 !important;
        }

        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 1200px) {
        .myOffers {
            max-width: 14.76666667% !important;
        }

        .input-date {
            width: 146px !important;
        }
    }

    @media (min-width: 1300px) {
        .input-date {
            width: 160px !important;
        }
    }

    @media (min-width: 1400px) {
        .input-date {
            width: 170px !important;
        }

        .myOffers {
            max-width: 12.66666667% !important;
        }
    }

    @media (min-width: 1500px) {
        .input-date {
            width: 190px !important;
        }
    }

    @media (min-width: 1600px) {
        .input-date {
            width: 200px !important;
        }

        .myOffers {
            max-width: 11.46666667% !important;
        }
    }

    @media (min-width: 1700px) {
        .input-date {
            width: 220px !important;
        }
    }

    @media (min-width: 1800px) {
        .input-date {
            width: 230px !important;
        }
    }

    @media (min-width: 1900px) {
        .input-date {
            width: 240px !important;
        }

        .myOffers {
            max-width: 8.66666667% !important;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/views/front/Users.vue